import * as React from 'react'

import {
  Button,
  Divider,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core'
import HistoryIcon from 'mdi-material-ui/History'

import Fetcher from '../../../components/Fetcher'
import Flex from '../../../components/Flex'
import Margin from '../../../components/Margin'
import TraderSettingsConfigCard from './TraderSettingsConfigCard'
import UploadFileButton from '../../../components/UploadFileButton'
import adviceService from '../../../services/adviceService'
import stockContributionService from '../../../services/stockContributionService'
import ImportHistoryDialog from './ImportHistoryDialog'
import { t } from '../../../i18n'
import theme from '../../../theme'

const styles = () =>
  createStyles({
    cardContent: {
      paddingRight: 15,
      width: '100%',
    },
    divider: {
      margin: theme.spacing.unit * 2,
    },
  })

interface Props extends WithStyles<typeof styles> {}

interface State {
  historyDialogOpen: boolean
}

class ContributionsSettings extends React.Component<Props, State> {
  readonly state: State = {
    historyDialogOpen: false,
  }

  openHistoryDialog = () => this.setState({ historyDialogOpen: true })

  closeHistoryDialog = () => this.setState({ historyDialogOpen: false })

  render() {
    const { classes } = this.props
    const { historyDialogOpen } = this.state

    return (
      <>
        <TraderSettingsConfigCard
          cardTitle={t('Vos apports')}
          adviceMessage={
            <>
              <Fetcher
                fetch={adviceService.findOne}
                fetchProps={['CONTRIBUTION']}
              >
                {advice => (
                  <div dangerouslySetInnerHTML={{ __html: advice.template }} />
                )}
              </Fetcher>
              <Divider variant="middle" className={classes.divider} />
              {t("Format du template d'import à respecter : ")}
              <br />
              <br />
              <Button
                href={`${process.env.PUBLIC_URL}/examples/import_stock_contributions.csv`}
              >
                {t('Exemple de fichier')}
              </Button>
            </>
          }
        >
          <Flex
            justify="center"
            alignItems="center"
            className={classes.cardContent}
          >
            <UploadFileButton
              size="large"
              action={stockContributionService.importCsv}
            />
            <Margin top={1}>
              <Button color="primary" onClick={this.openHistoryDialog}>
                <HistoryIcon /> {t('Historique des imports')}
              </Button>
            </Margin>
          </Flex>
        </TraderSettingsConfigCard>
        {historyDialogOpen && (
          <ImportHistoryDialog open onClose={this.closeHistoryDialog} />
        )}
      </>
    )
  }
}

export default withStyles(styles)(ContributionsSettings)
